import { useEffect, useState } from "react";

export const useCountDown = (initialValue = 60, interval = 1000) => {
  const storedCount = sessionStorage.getItem("count");
  const [count, setCount] = useState(
    storedCount ? parseInt(storedCount, 10) : 0
  );

  useEffect(() => {
    let timer: any;

    if (count > 0) {
      timer = setInterval(() => {
        setCount((prevCount) => {
          const newCount = prevCount - 1;
          sessionStorage.setItem("count", newCount.toString());
          return newCount;
        });
      }, interval);
    }

    return () => {
      clearInterval(timer);
    };
  }, [count, interval]);

  const resetCountdown = () => {
    sessionStorage.removeItem("count");
    setCount(initialValue);
  };

  const stopCountdown = () => {
    sessionStorage.removeItem("count");
    setCount(0);
  };

  return { count, stopCountdown, resetCountdown };
};

export default useCountDown;
